import api from "./api";

export const getRankings = (page, params) => {
  return api.get("admin/Ranking", { params: { page: page, limit: 5, ...params} });
};

export const createRanking = ({sqlCommand, limit, name, i18n}) => {
  return api.post("admin/ranking", { sqlCommand, limit, name, i18n });
};

export const updateRanking = (uid, { sqlCommand, limit, name, i18n }) => {
  return api.put(`admin/ranking/${uid}`, { sqlCommand, limit, name, i18n});
};

export const enableRanking = (uid, enabled) => {
  return api.post(`admin/ranking/${uid}/enable`, { enabled });
};

export const approveRanking = (uid, approved) => {
  return api.post(`admin/ranking/${uid}/approval`, { approved });
};

export const getRankingBySearch = (searchItem, search) => {
  return api.get(`admin/Ranking?searchItem=${searchItem}&search=${search}`);
};
    
export const getRankingByOrder = (item, direction) => {
  return api.get(`admin/Ranking?order=${item}&direction=${direction}`);
};

